"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgChevronRight(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "8 -4 8 24" }, props),
        React.createElement("path", { d: "M13.94 8l-5.47 5.47a.75.75 0 001.06 1.06l6-6a.75.75 0 000-1.06l-6-6a.75.75 0 00-1.06 1.06z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('ChevronRight')(SvgChevronRight);
//# sourceMappingURL=ChevronRight.js.map